import React from "react";
import { render, screen } from "@testing-library/react";
import { renderElementPreview } from "./CanvasBuilder";
import type { CanvasBuilderElement } from "./canvasBuilderProjection";

jest.mock("../components/MyVaultAgent", () => ({
  FloatingChatWidget: () => null,
}));

describe("CanvasBuilder Kanban editor preview", () => {
  it("shows the configured source, status field, and columns", () => {
    const kanban: CanvasBuilderElement = {
      tempId: "kanban-1",
      id: "kanban-1",
      type: "kanban",
      props: {
        label: "Work items",
        title: "Project status",
        data_source_alias: "projects",
        status_field: "status",
        columns: ["Planned", "Active", "Complete"],
      },
      layout: { order: 0 },
      gridColumn: 1,
      gridRow: 1,
      columnSpan: 6,
      rowSpan: 4,
    };

    render(
      <>
        {renderElementPreview(
          kanban,
          [kanban],
          null,
          null,
          jest.fn(),
          jest.fn(),
        )}
      </>,
    );

    expect(screen.getByTestId("kanban-editor-preview")).toBeTruthy();
    expect(screen.getByText("Project status")).toBeTruthy();
    expect(screen.getByText("Data source: projects")).toBeTruthy();
    expect(screen.getByText("Status field: status")).toBeTruthy();
    for (const column of ["Planned", "Active", "Complete"]) {
      expect(screen.getByText(column)).toBeTruthy();
    }
  });
});
